/* eslint-disable jsx-a11y/no-noninteractive-element-interactions,jsx-a11y/click-events-have-key-events */
import React from 'react';
import {
  OutlinedButton,
  TonalButton,
  ButtonType,
  ButtonSize,
} from '@prisjakt/ui/button/variants';

import { bool } from 'prop-types';
import ExperimentContext from './context';
import * as S from './styles';

const fromKebab = s => s.replace(/-/g, ' ');
const fromCamel = s => s.replace(/([a-z])([A-Z])/g, '$1 $2');
const unCase = s => fromCamel(fromKebab(s));

class Editor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mounted: false,
      open: false,
      experiment: undefined,
    };
  }

  static propTypes = {
    isFixed: bool,
  };

  static defaultProps = {
    isFixed: true,
  };

  componentDidMount() {
    this.setState({ mounted: true });
  }

  isActive(experiment, variant) {
    const { selectedVariants } = this.props;

    if (!selectedVariants[experiment.id] && variant === 'baseline') {
      return true;
    }

    if (!selectedVariants[experiment.id]) {
      return false;
    }

    return selectedVariants[experiment.id].selectedVariant === variant;
  }

  open = () => {
    this.setState({ open: true });
  };

  close = () => {
    this.setState({ open: false });
  };

  render() {
    const { open, experiment, mounted } = this.state;
    let editor;
    if (!open) {
      editor = (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events
        <S.Editor open={false} isFixed={this.props.isFixed}>
          <img
            onClick={this.open}
            width="24"
            height="24"
            alt=""
            src="https://cdn.pji.nu/g/logo/icon192x192.png"
          />
        </S.Editor>
      );
    } else {
      editor = (
        <S.Editor isFixed={this.props.isFixed} open>
          <img
            onClick={this.close}
            width="24"
            height="24"
            alt=""
            src="https://cdn.pji.nu/g/logo/icon192x192.png"
          />

          {experiment && (
            <S.Menu>
              <OutlinedButton
                size={ButtonSize.SMALL}
                onClick={() =>
                  this.setState({
                    experiment: undefined,
                  })
                }
              >
                {unCase(experiment.id)}
              </OutlinedButton>

              {['baseline']
                .concat(Object.keys(experiment.variants))
                .map(variant => (
                  <TonalButton
                    size={ButtonSize.SMALL}
                    key={variant}
                    type={
                      this.isActive(experiment, variant)
                        ? ButtonType.PRIMARY
                        : ButtonType.TONAL
                    }
                    onClick={() => {
                      if (this.props.selectedVariant) {
                        this.props.selectedVariant(experiment, variant);
                      }
                    }}
                  >
                    {unCase(variant)}
                  </TonalButton>
                ))}
            </S.Menu>
          )}
          {!experiment && (
            <S.Menu>
              {this.props.experiments.map(exp => (
                <OutlinedButton
                  size={ButtonSize.SMALL}
                  key={exp.id}
                  onClick={() => {
                    this.setState({
                      experiment: exp,
                    });
                  }}
                >
                  {unCase(exp.id)}
                </OutlinedButton>
              ))}
            </S.Menu>
          )}
        </S.Editor>
      );
    }
    return mounted ? editor : null;
  }
}

export default ({ isFixed = true }) => (
  <ExperimentContext.Consumer>
    {({ selectedVariants, experiments, selectedVariant, showEditor }) => {
      if (!showEditor) {
        return null;
      }
      return (
        <Editor
          selectedVariants={selectedVariants}
          experiments={experiments}
          selectedVariant={selectedVariant}
          isFixed={isFixed}
        />
      );
    }}
  </ExperimentContext.Consumer>
);
